import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { FIELDS } from './validation/fields';
import AppInput from '../AppInput';
import ReCAPTCHA from '../ReCaptcha';
import ProductList from './ProductList';
import Message from '../Message';
import { getProducts } from '../../../redux/actions/ProductsActions';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import MotiveTitle from '../../views/Contact/Motive/MotiveTitle';
import { resetGet } from '../../../redux/slices/ProducsSlice';
import { setIsValidReCaptcha } from '../../../redux/slices/reCaptchaSlice';
import { textMapper } from '../../../helpers/FormHelper';
import { useFormStyles } from './styles';
import LoadingButton from '../LoadingButton';
import { schema } from './validation/schema';
import { INSERT_MAIN_DATA } from '../../../constants/texts';

const Form = ({ ...props }) => {
  const { state, onData, valid, mobile, motiveId, issueFormName } = props;

  const reduxDispatch = useDispatch();
  const classes = useFormStyles();
  const { getStatus, products, errorMessage } = useSelector(
    (state) => state.productsReducer,
  );
  const { reCaptchaToken, isValidReCaptcha } = useSelector(
    (state) => state.reCaptchaSlice,
  );
  const [showOcCaptcha, setShowOcCaptcha] = useState(false);

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });

    let fieldsValidate = schema.validate({ [e.target.name]: e.target.value });
    if ('error' in fieldsValidate) {
      setShowOcCaptcha(false);
      resetCaptcha();
    } else setShowOcCaptcha(true);
  };

  useEffect(() => {
    if (!valid) reduxDispatch(resetGet());
  }, [valid]);

  useEffect(() => {
    if (getStatus === 'error') resetCaptcha();
  }, [getStatus]);

  const onClick = () => {
    const oc = state['orderId'].value;
    if (valid) reduxDispatch(getProducts({ oc, reCaptchaToken }));
  };

  const resetCaptcha = () => {
    reduxDispatch(setIsValidReCaptcha(false));
  };

  return (
    <React.Fragment>
      {mobile && (
        <React.Fragment>
          <MotiveTitle
            icon={textMapper.get(motiveId).icon}
            title={textMapper.get(motiveId).title}
            subtitle={textMapper.get(motiveId).subtitle}
            mobile={mobile}
          />
          <Typography className={classes.title}>{INSERT_MAIN_DATA}</Typography>
        </React.Fragment>
      )}
      {FIELDS.map((field, index) => (
        <AppInput
          key={index}
          issueFormName={issueFormName}
          onChange={handleChange}
          onBlur={() => {}}
          onClick={() => {}}
          disabled={state[field.name]?.disabled || false}
          name={field.name}
          error={state[field.name]?.error || false}
          type={state[field.name]?.type || ''}
          label={state[field.name]?.label || ''}
          required={state[field.name]?.required || false}
          inputAdornment={state[field.name]?.inputAdornment || ''}
          success={state[field.name]?.success || false}
          helperText={state[field.name]?.helper || ''}
          errorMessage={state[field.name]?.message || ''}
        />
      ))}
      {showOcCaptcha && getStatus !== 'succeded' && (
        <React.Fragment>
          <ReCAPTCHA />
          <LoadingButton
            name="GetProductList"
            onClick={onClick}
            variant="contained"
            color="primary"
            text="Consultar"
            disabled={!valid || !isValidReCaptcha}
          />
        </React.Fragment>
      )}
      {getStatus === 'loading' && (
        <Box marginTop="26px" display="flex" justifyContent="center">
          <CircularProgress color="primary" />
        </Box>
      )}
      {getStatus === 'succeded' && (
        <ProductList
          motiveId={motiveId}
          products={products}
          orderId={state['orderId']?.value || ''}
          mobile={mobile}
          state={state}
          issueFormName={issueFormName}
        />
      )}
      {getStatus === 'error' && (
        <Box marginTop="26px">
          <Message severity="alert" message={errorMessage} fullRounded />
        </Box>
      )}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  valid: PropTypes.bool,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueFormName: PropTypes.string,
};

export default Form;
